import { useSelector, useDispatch } from "react-redux";
import {
  PAGE_VIEWED, TRACK_SCREEN_VIEW_STREAM_DETAIL, TRACK_SCREEN_VIEW_STREAM_SELECTION, TRACK_SCREEN_VIEW_STREAM_EDIT,
  TRACK_SCREEN_VIEW_STREAM_DELETE, TRACK_SCREEN_VIEW_GROUP_DETAIL, TRACK_SCREEN_VIEW_CONNECTED_SOURCE, TRACK_SCREEN_VIEW_MANAGE_USER_ACCESS,
  TRACK_STREAM_VIEWED_EVENT, TRACK_GROUP_VIEWED_EVENT, TRACK_MANAGE_SOURCE_SCREEN_VIEW, TRACK_STREAM_ADDED_EVENT, TRACK_ADD_GROUP_CLICKED_EVENT,
  TRACK_ADD_GROUP_CONFIRM_CLICKED_EVENT, TRACK_GROUP_ADDED_EVENT, TRACK_ADD_ASSET_CLICKED_EVENT, TRACK_RENAME_CLICKED_EVENT,
  TRACK_RENAME_CONFIRM_CLICKED_EVENT, TRACK_ASSET_RENAMED_EVENT, TRACK_GROUP_RENAMED_EVENT, TRACK_DELETE_CLICKED_EVENT,
  TRACK_DELETE_CONFIRM_CLICKED_EVENT, TRACK_ASSET_DELETED_EVENT, TRACK_GROUP_DELETED_EVENT, TRACK_COPY_CLICKED_EVENT,
  TRACK_COPY_CONFIRM_CLICKED_EVENT, TRACK_COPY_STREAM_SELECTED_EVENT, TRACK_ASSET_COPIED_EVENT, TRACK_GROUP_COPIED_EVENT,
  TRACK_MOVE_CLICKED_EVENT, TRACK_MOVE_CONFIRM_CLICKED_EVENT, TRACK_MOVE_STREAM_SELECTED_EVENT, TRACK_ASSET_MOVED_EVENT,
  TRACK_GROUP_MOVED_EVENT, TRACK_MANAGE_SOURCE_CLICKED_EVENT, TRACK_MAP_NEW_FOLDER_CLICKED_EVENT, TRACK_CONNECTED_SOURCE_SELECTED_EVENT,
  TRACK_FOLDER_SELECTED_EVENT, TRACK_SOURCE_ADDED_EVENT, TRACK_EDIT_GROUP_CLICKED_EVENT, TRACK_GROUP_EDITED_EVENT,
  TRACK_EDIT_STREAM_CLICKED_EVENT, TRACK_EDIT_STREAM_CONFIRM_CLICKED_EVENT, TRACK_CHANGE_BACKGROUND_CLICKED_EVENT,
  TRACK_ADD_BANNER_CLICKED_EVENT, TRACK_BANNER_CONTENT_SELECTED_EVENT, TRACK_CROP_BANNER_CLICKED_EVENT,
  TRACK_BANNER_CROPPED_EVENT, TRACK_BANNER_ADDED_EVENT, TRACK_BACKGROUND_IMAGE_ADDED_EVENT, TRACK_STREAM_EDITED_EVENT, 
  TRACK_DELETE_STREAM_CLICKED_EVENT, TRACK_DELETE_STREAM_CONFIRM_CLICKED_EVENT, TRACK_STREAM_DELETED_EVENT, 
  TRACK_MANAGE_USER_ACCESS_CLICKED_EVENT, TRACK_USER_ACCESS_UPDATED_EVENT,
  TRACK_CONTENT_HUB_STREAM_CREATED_EVENT
} from "src/constants/adoption/eventTypes";
import { trackEventForAdoption } from "../adoption";
import {
  StreamDetailViewed, StreamViewed, GroupDetailViewed, StreamAdded, AddGroupClicked, AddGroupConfirmClicked,
  GroupAdded, AddAssetClicked, RenameClicked, RenameConfirmClicked,
  AssetRenamed, GroupRenamed, DeleteClicked, DeleteConfirmClicked,
  AssetDeleted, GroupDeleted, CopyClicked, CopyConfirmClicked,
  CopyStreamSelected, AssetsCopied, GroupsCopied, MoveClicked,
  MoveConfirmClicked, MoveStreamSelected, AssetsMoved, GroupsMoved,
  ManageSourceClicked, MapNewFolderClicked, ConnectedSourceSelected,
  FolderSelected, TrackSourceAdded, EditGroupClicked, GroupEdited,
  EditStreamClicked, EditStreamConfirmClicked, ChangeBackgroundClicked, 
  BannerContentSelected, CropBannerClicked, BannerCropped,
  BannerAdded, BackgroundImageAdded, StreamEdited,
  DeleteStreamClicked, DeleteStreamConfirmClicked, StreamDeleted, ManageUserAccessClicked,
  StreamCreated
} from "src/types/adoption/streams";
import { STREAM, GROUP } from "src/constants/adoption/sourceTypes";
import _ from "lodash";
import { FileService } from "src/services/file.service";

export const useStreamsAdoption = () => {

  const dispatch = useDispatch();

  const streams = useSelector((state: any) => state.stream);
  const groups = useSelector((state: any) => state.group);

  // screen views

  // stream detail viewed
  const trackStreamDetailViewed = ({ sourceCta }: StreamDetailViewed) => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_SCREEN_VIEW_STREAM_DETAIL,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // stream selection viewed
  const trackStreamSelectionViewed = () => {

    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_SCREEN_VIEW_STREAM_SELECTION
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // stream edit viewed
  const trackStreamEditViewed = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_SCREEN_VIEW_STREAM_EDIT
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // stream delete viewed
  const trackStreamDeleteViewed = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_SCREEN_VIEW_STREAM_DELETE
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // group detail viewed
  const trackGroupDetailViewed = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_SCREEN_VIEW_GROUP_DETAIL
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // connected sources viewed 
  const trackConnectedSourcesViewed = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_SCREEN_VIEW_CONNECTED_SOURCE
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // manage user access viewed 
  const trackManageUserAccessViewed = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_SCREEN_VIEW_MANAGE_USER_ACCESS
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // stream viewed
  const trackStreamViewed = ({ sourceCta }: StreamViewed) => {
    const event = {
      event: TRACK_STREAM_VIEWED_EVENT,
      properties: {
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // manage source viewed
  const trackManageSourceScreenView = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_MANAGE_SOURCE_SCREEN_VIEW
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //group viewed
  const trackGroupViewed = ({ sourceCta, groupId, streamId }: GroupDetailViewed) => {

    const groupName = _.get(groups[groupId], 'item.name', '');
    const streamName = _.get(streams, `items[${streamId}]item.name`, '');

    const event = {
      event: TRACK_GROUP_VIEWED_EVENT,
      properties: {
        source_cta: sourceCta,
        group_name: groupName,
        stream_name: streamName
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //stream added
  const trackStreamAdded = ({ streamName, streamDescription }: StreamAdded) => {
    const event = {
      event: TRACK_STREAM_ADDED_EVENT,
      properties: {
        stream_name: streamName,
        stream_description: streamDescription
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  //add group clicked
  const trackAddGroupClicked = ({ streamId, groupId }: AddGroupClicked) => {

    const stream_name = _.get(streams, `items[${streamId}]item.name`, '');
    const source_group_name = _.get(groups[groupId], 'item.name', '');
    const sourceCta = source_group_name ? GROUP : STREAM;

    const event = {
      event: TRACK_ADD_GROUP_CLICKED_EVENT,
      properties: {
        stream_name,
        source_group_name,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // add group confirm clicked
  const trackAddGroupConfirmClicked = ({ streamId, group_name, sourceGroupId }: AddGroupConfirmClicked) => {

    const stream_name = _.get(streams, `items[${streamId}]item.name`, '');
    const source_group_name = _.get(groups[sourceGroupId], 'item.name', '');
    const sourceCta = source_group_name ? GROUP : STREAM;

    const event = {
      event: TRACK_ADD_GROUP_CONFIRM_CLICKED_EVENT,
      properties: {
        stream_name,
        group_name,
        source_group_name,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }


  // group added
  const trackGroupAdded = ({ groupName, streamId, sourceGroupId }: GroupAdded) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`, '');
    const sourceGroupName = sourceGroupId && _.get(groups[sourceGroupId], 'item.name', '');
    const sourceCta = sourceGroupId ? GROUP : STREAM;

    const event = {
      event: TRACK_GROUP_ADDED_EVENT,
      properties: {
        group_name: groupName,
        stream_name: streamName,
        source_group_name: sourceGroupName,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // add asset clicked
  const trackAddAssetClicked = ({ streamId, groupId }: AddAssetClicked) => {

    const stream_name = _.get(streams, `items[${streamId}].item.name`, '');
    const source_group_name = _.get(groups[groupId], 'item.name', '');
    const sourceCta = source_group_name ? GROUP : STREAM;

    const event = {
      event: TRACK_ADD_ASSET_CLICKED_EVENT,
      properties: {
        stream_name,
        source_group_name,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // rename clicked
  const trackRenameClicked = ({ streamId, sourceCta }: RenameClicked) => {

    const stream_name = _.get(streams, `items[${streamId}].item.name`, '');

    const event = {
      event: TRACK_RENAME_CLICKED_EVENT,
      properties: {
        stream_name,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // rename confirm clicked
  const trackRenameConfirmClicked = ({ streamId, groupIds, assetIds, sourceGroupId }: RenameConfirmClicked) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`);
    const streamChildren = _.get(streams, `items[${streamId}].item.children`, []);
    const groupChildren = _.get(groups, `${sourceGroupId}.item.children`, []);
    const sourceCta = sourceGroupId ? GROUP : STREAM;
    const children = sourceGroupId ? groupChildren : streamChildren;

    const assetNames = _.map(_.filter(children, (child: any) => assetIds.includes(child.id)), 'name');

    let assetTypes = _.map(_.filter(children, (child: any) => assetIds.includes(child.id)), (child: any) => _.upperCase(child.metadata.extension));

    const groupNames = _.map(_.filter(children, (child: any) => groupIds.includes(child.id)), 'name');

    const event = {
      event: TRACK_RENAME_CONFIRM_CLICKED_EVENT,
      properties: {
        stream_name: streamName,
        asset_name: assetNames,
        group_name: groupNames,
        asset_type: assetTypes,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // asset renamed 
  const trackAssetRenamed = ({ streamId, groupId, response }: AssetRenamed) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`);
    const assetName = _.get(response, 'name', '');
    const assetType = _.upperCase(_.get(response, 'metadata.extension', ''));
    const sourceCta = groupId ? GROUP : STREAM;

    const event = {
      event: TRACK_ASSET_RENAMED_EVENT,
      properties: {
        stream_name: streamName,
        asset_name: assetName,
        asset_type: assetType,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // group renamed
  const trackGroupRenamed = ({ streamId, groupId }: GroupRenamed) => {

    const stream_name = _.get(streams, `items[${streamId}].item.name`);
    const group_name = groupId && _.get(groups[groupId], 'item.name', '');
    const sourceCta = groupId ? GROUP : STREAM;

    const event = {
      event: TRACK_GROUP_RENAMED_EVENT,
      properties: {
        stream_name: stream_name,
        group_name: group_name,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // delete clicked
  const trackDeleteClicked = ({ streamId, sourceCta }: DeleteClicked) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`);

    const event = {
      event: TRACK_DELETE_CLICKED_EVENT,
      properties: {
        stream_name: streamName,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // delete confirm clicked
  const trackDeleteConfirmClicked = ({ streamId, assetIds, groupIds, sourceGroupId }: DeleteConfirmClicked) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`);
    const streamChildren = _.get(streams, `items[${streamId}].item.children`, []);
    const groupChildren = _.get(groups, `${sourceGroupId}.item.children`, []);
    const sourceCta = sourceGroupId ? GROUP : STREAM;
    const children = sourceGroupId ? groupChildren : streamChildren;

    const assetNames = _.map(_.filter(children, (child: any) => assetIds.includes(child.id)), 'name');

    let assetTypes = _.map(_.filter(children, (child: any) => assetIds.includes(child.id)), (child: any) => _.upperCase(child.metadata.extension));

    const groupNames = _.map(_.filter(children, (child: any) => groupIds.includes(child.id)), 'name');

    const event = {
      event: TRACK_DELETE_CONFIRM_CLICKED_EVENT,
      properties: {
        stream_name: streamName,
        asset_name: assetNames,
        group_name: groupNames,
        asset_type: assetTypes,
        sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }


  // asset deleted 
  const trackAssetDeleted = ({ response, sourceCta, sectionType }: AssetDeleted) => {

    const assetName = response.map((item: any) => item.name);
    const assetType = response.map((item: any) =>  _.upperCase(FileService.getFileType(item.metadata)));

    const event = {
      event: TRACK_ASSET_DELETED_EVENT,
      properties: {
        asset_name: assetName,
        asset_type: assetType,
        source_cta: sourceCta,
         ...(sectionType && { content_section_type: sectionType })
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // group deleted
  // const trackGroupDeleted = ({ stream_name, group_name, asset_type }: GroupDeleted) => {
  //   const event = {
  //     event: TRACK_GROUP_DELETED_EVENT,
  //     properties: {
  //       stream_name,
  //       group_name,
  //       asset_type,
  //       // source_cta
  //     }
  //   }

  //   dispatch(trackEventForAdoption(event));
  // }

  // copy clicked
  const trackCopyClicked = ({ sourceStreamId, sourceCta }: CopyClicked) => {

    const sourceStreamName = _.get(streams, `items[${sourceStreamId}].item.name`);

    const event = {
      event: TRACK_COPY_CLICKED_EVENT,
      properties: {
        source_stream_name: sourceStreamName,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // copy confirm clicked
  const trackCopyConfirmClicked = ({ streamId, assetIds, groupIds, sourceGroupId }: CopyConfirmClicked) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`);
    const streamChildren = _.get(streams, `items[${streamId}].item.children`, []);
    const groupChildren = _.get(groups, `${sourceGroupId}.item.children`, []);
    const sourceCta = sourceGroupId ? GROUP : STREAM;
    const children = sourceGroupId ? groupChildren : streamChildren;

    const assetNames = _.map(_.filter(children, (child: any) => assetIds.includes(child.id)), 'name');

    let assetTypes = _.map(_.filter(children, (child: any) => assetIds.includes(child.id)), (child: any) => _.upperCase(child.metadata.extension));

    const groupNames = _.map(_.filter(children, (child: any) => groupIds.includes(child.id)), 'name');

    const event = {
      event: TRACK_COPY_CONFIRM_CLICKED_EVENT,
      properties: {
        source_stream_name: streamName,
        asset_name: assetNames,
        group_name: groupNames,
        asset_type: assetTypes,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // copy stream selected
  const trackCopyStreamSelected = ({ streamId, groupIds, assetIds, destinationStreamName, sourceGroupId }: CopyStreamSelected) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`);
    const streamChildren = _.get(streams, `items[${streamId}].item.children`, []);
    const groupChildren = _.get(groups, `${sourceGroupId}.item.children`, []);
    const sourceCta = sourceGroupId ? GROUP : STREAM;
    const children = sourceGroupId ? groupChildren : streamChildren;

    const assetNames = _.map(_.filter(children, (child: any) => assetIds.includes(child.id)), 'name');

    let assetTypes = _.map(_.filter(children, (child: any) => assetIds.includes(child.id)), (child: any) => _.upperCase(child.metadata.extension));

    const groupNames = _.map(_.filter(children, (child: any) => groupIds.includes(child.id)), 'name');

    const event = {
      event: TRACK_COPY_STREAM_SELECTED_EVENT,
      properties: {
        source_stream_name: streamName,
        asset_name: assetNames,
        group_name: groupNames,
        asset_type: assetTypes,
        destination_stream_name: destinationStreamName,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // asset copied
  const trackAssetsCopied = ({ sourceStream, sourceGroup, entities, destination }: AssetsCopied) => {

    const sourceType = sourceGroup ? _.get(sourceGroup, 'entityType') : _.get(sourceStream, 'entityType');
    const sourceStreamName = _.get(sourceStream, 'name', '');
    const sourceCta = sourceType === 'group' ? GROUP : STREAM;
    const assetNames = _.map(entities, 'name');
    const assetTypes = _.map(entities, (entity: any) => _.upperCase(entity.metadata.extension));
    const destinationName = _.get(destination, 'name', '');

    const event = {
      event: TRACK_ASSET_COPIED_EVENT,
      properties: {
        source_stream_name: sourceStreamName,
        asset_name: assetNames,
        asset_type: assetTypes,
        destination_stream_name: destinationName,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // group copied
  const trackGroupsCopied = ({ sourceStream, sourceGroup, entities, destination }: GroupsCopied) => {

    const sourceType = sourceGroup ? _.get(sourceGroup, 'entityType') : _.get(sourceStream, 'entityType');
    const sourceStreamName = _.get(sourceStream, 'name', '');
    const sourceCta = sourceType === 'group' ? GROUP : STREAM;
    const groupNames = _.map(entities, 'name');
    const destinationName = _.get(destination, 'name', '');

    const event = {
      event: TRACK_GROUP_COPIED_EVENT,
      properties: {
        source_stream_name: sourceStreamName,
        group_name: groupNames,
        destination_stream_name: destinationName,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // move clicked
  const trackMoveClicked = ({ sourceStreamId, sourceCta }: MoveClicked) => {

    const sourceStreamName = _.get(streams, `items[${sourceStreamId}].item.name`);

    const event = {
      event: TRACK_MOVE_CLICKED_EVENT,
      properties: {
        source_stream_name: sourceStreamName,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // move confirm clicked
  const trackMoveConfirmClicked = ({ streamId, assetIds, groupIds, sourceGroupId }: MoveConfirmClicked) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`);
    const streamChildren = _.get(streams, `items[${streamId}].item.children`, []);
    const groupChildren = _.get(groups, `${sourceGroupId}.item.children`, []);
    const sourceCta = sourceGroupId ? GROUP : STREAM;
    const children = sourceGroupId ? groupChildren : streamChildren;

    const assetNames = _.map(_.filter(children, (child: any) => assetIds.includes(child.id)), 'name');

    let assetTypes = _.map(_.filter(children, (child: any) => assetIds.includes(child.id)), (child: any) => _.upperCase(child.metadata.extension));

    const groupNames = _.map(_.filter(children, (child: any) => groupIds.includes(child.id)), 'name');

    const event = {
      event: TRACK_MOVE_CONFIRM_CLICKED_EVENT,
      properties: {
        source_stream_name: streamName,
        asset_type: assetTypes,
        asset_name: assetNames,
        group_name: groupNames,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // move stream selected
  const trackMoveStreamSelected = ({ streamId, groupIds, assetIds, destinationStreamName, sourceGroupId }: MoveStreamSelected) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`);
    const streamChildren = _.get(streams, `items[${streamId}].item.children`, []);
    const groupChildren = _.get(groups, `${sourceGroupId}.item.children`, []);
    const sourceCta = sourceGroupId ? GROUP : STREAM;
    const children = sourceGroupId ? groupChildren : streamChildren;

    const assetNames = _.map(_.filter(children, (child: any) => assetIds.includes(child.id)), 'name');

    let assetTypes = _.map(_.filter(children, (child: any) => assetIds.includes(child.id)), (child: any) => _.upperCase(child.metadata.extension));

    const groupNames = _.map(_.filter(children, (child: any) => groupIds.includes(child.id)), 'name');

    const event = {
      event: TRACK_MOVE_STREAM_SELECTED_EVENT,
      properties: {
        source_stream_name: streamName,
        asset_type: assetTypes,
        asset_name: assetNames,
        group_name: groupNames,
        source_cta: sourceCta,
        destination_stream_name: destinationStreamName
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // asset moved
  const trackAssetsMoved = ({ sourceStream, sourceGroup, entities, destination }: AssetsMoved) => {

    const sourceType = sourceGroup ? _.get(sourceGroup, 'entityType') : _.get(sourceStream, 'entityType');
    const sourceStreamName = _.get(sourceStream, 'name', '');
    const sourceCta = sourceType === 'group' ? GROUP : STREAM;
    const assetNames = _.map(entities, 'name');
    const assetTypes = _.map(entities, (entity: any) => _.upperCase(entity.metadata.extension));
    const destinationName = _.get(destination, 'name', '');

    const event = {
      event: TRACK_ASSET_MOVED_EVENT,
      properties: {
        source_stream_name: sourceStreamName,
        asset_name: assetNames,
        asset_type: assetTypes,
        source_cta: sourceCta,
        destination_stream_name: destinationName
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // group moved 
  const trackGroupsMoved = ({ sourceStream, sourceGroup, entities, destination }: GroupsMoved) => {

    const sourceType = sourceGroup ? _.get(sourceGroup, 'entityType') : _.get(sourceStream, 'entityType');
    const sourceStreamName = _.get(sourceStream, 'name', '');
    const sourceCta = sourceType === 'group' ? GROUP : STREAM;
    const groupNames = _.map(entities, 'name');
    const destinationName = _.get(destination, 'name', '');

    const event = {
      event: TRACK_GROUP_MOVED_EVENT,
      properties: {
        source_stream_name: sourceStreamName,
        group_name: groupNames,
        source_cta: sourceCta,
        destination_stream_name: destinationName
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // manage source clicked
  const trackManageSourceClicked = ({ streamId, groupId }: ManageSourceClicked) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`, '');
    const groupName = groupId && _.get(groups[groupId], 'item.name', '');
    const sourceCta = groupName ? GROUP : STREAM;

    const event = {
      event: TRACK_MANAGE_SOURCE_CLICKED_EVENT,
      properties: {
        stream_name: streamName,
        group_name: groupName,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // map new folder clicked
  const trackMapNewFolderClicked = ({ streamId, groupId }: MapNewFolderClicked) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`, '');
    const groupName = groupId && _.get(groups[groupId], 'item.name', '');
    const sourceCta = groupId ? GROUP : STREAM;

    const event = {
      event: TRACK_MAP_NEW_FOLDER_CLICKED_EVENT,
      properties: {
        stream_name: streamName,
        group_name: groupName,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // connected source selected
  const trackConnectedSourceSelected = ({ streamId, groupId }: ConnectedSourceSelected) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`, '');
    const groupName = groupId && _.get(groups[groupId], 'item.name', '');
    const sourceCta = groupId ? GROUP : STREAM;

    const event = {
      event: TRACK_CONNECTED_SOURCE_SELECTED_EVENT,
      properties: {
        stream_name: streamName,
        group_name: groupName,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // folder selected
  const trackFolderSelected = ({ streamId, groupId, folderName }: FolderSelected) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`, '');
    const groupName = groupId && _.get(groups[groupId], 'item.name', '');
    const sourceCta = groupId ? GROUP : STREAM;

    const event = {
      event: TRACK_FOLDER_SELECTED_EVENT,
      properties: {
        stream_name: streamName,
        group_name: groupName,
        folder_name: folderName,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // source added
  const trackSourceAdded = ({ response }: TrackSourceAdded) => {

    const source = _.get(response, 'target.entityType');
    const sourceCta = source === 'group' ? GROUP : STREAM;
    const streamName = sourceCta === STREAM ? _.get(response, 'target.name', '') : '';
    const groupName = sourceCta === GROUP ? _.get(response, 'target.name', '') : '';
    const folderName = _.get(response, 'folder', '');

    const event = {
      event: TRACK_SOURCE_ADDED_EVENT,
      properties: {
        stream_name: streamName,
        group_name: groupName,
        folder_name: folderName,
        source_cta: sourceCta
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // edit group clicked
  const trackEditGroupClicked = ({ streamId, groupId }: EditGroupClicked) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`, '');
    const groupName = _.get(groups[groupId], 'item.name', '');

    const event = {
      event: TRACK_EDIT_GROUP_CLICKED_EVENT,
      properties: {
        stream_name: streamName,
        group_name: groupName,
        source_cta: GROUP
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // group edited
  const trackGroupEdited = ({ streamId, group }: GroupEdited) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`, '');
    const groupName = _.get(group, 'name', '');
    const groupDescription = _.get(group, 'summary', '');

    const event = {
      event: TRACK_GROUP_EDITED_EVENT,
      properties: {
        stream_name: streamName,
        group_name: groupName,
        group_description: groupDescription,
        source_cta: GROUP
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // edit stream clicked
  const trackEditStreamClicked = ({ streamId }: EditStreamClicked) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`, '');

    const event = {
      event: TRACK_EDIT_STREAM_CLICKED_EVENT,
      properties: {
        stream_name: streamName,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // edit stream confirm clicked
  const trackEditStreamConfirmClicked = ({ streamName, streamDescription }: EditStreamConfirmClicked) => {

    const event = {
      event: TRACK_EDIT_STREAM_CONFIRM_CLICKED_EVENT,
      properties: {
        stream_name: streamName,
        stream_description: streamDescription
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // change background clicked
  const trackChangeBackgroundClicked = ({ streamId }: ChangeBackgroundClicked) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`, '');

    const event = {
      event: TRACK_CHANGE_BACKGROUND_CLICKED_EVENT,
      properties: {
        stream_name: streamName,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // add banner clicked
  const trackAddBannerClicked = () => {

    const event = {
      event: TRACK_ADD_BANNER_CLICKED_EVENT,
      properties: {
        source_cta: STREAM,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // banner content selected
  const trackBannerContentSelected = ({ bannerType }: BannerContentSelected) => {

    const banner_type = _.capitalize(bannerType);

    const event = {
      event: TRACK_BANNER_CONTENT_SELECTED_EVENT,
      properties: {
        banner_type: banner_type,
        source_cta: STREAM
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // // crop banner clicked
  const trackCropBannerClicked = ({ bannerType }: CropBannerClicked) => {

    const banner_type = _.capitalize(bannerType);

    const event = {
      event: TRACK_CROP_BANNER_CLICKED_EVENT,
      properties: {
        banner_type: banner_type,
        source_cta: STREAM
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // banner cropped
  const trackBannerCropped = ({ bannerType }: BannerCropped) => {

    const banner_type = _.capitalize(bannerType);

    const event = {
      event: TRACK_BANNER_CROPPED_EVENT,
      properties: {
        banner_type: banner_type,
        source_cta: STREAM
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // // banner added
  const trackBannerAdded = ({ bannerType }: BannerAdded) => {

    const banner_type = _.capitalize(bannerType);

    const event = {
      event: TRACK_BANNER_ADDED_EVENT,
      properties: {
        banner_type: banner_type,
        source_cta: STREAM
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // // background image added
  const trackBackgroundImageAdded = ({ bannerType }: BackgroundImageAdded) => {

    const banner_type = _.capitalize(bannerType);

    const event = {
      event: TRACK_BACKGROUND_IMAGE_ADDED_EVENT,
      properties: {
        banner_type: banner_type,
        source_cta: STREAM
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // stream edited
  const trackStreamEdited = ({ stream }: StreamEdited) => {

    const streamName = _.get(stream, `name`, '');
    const streamDescription = _.get(stream, `summary`, '');

    const event = {
      event: TRACK_STREAM_EDITED_EVENT,
      properties: {
        stream_name: streamName,
        stream_description: streamDescription
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // delete stream clicked
  const trackDeleteStreamClicked = ({ streamId }: DeleteStreamClicked) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`, '');

    const event = {
      event: TRACK_DELETE_STREAM_CLICKED_EVENT,
      properties: {
        stream_name: streamName,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // delete stream confirm clicked
  const trackDeleteStreamConfirmClicked = ({ streamId }: DeleteStreamConfirmClicked) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`, '');

    const event = {
      event: TRACK_DELETE_STREAM_CONFIRM_CLICKED_EVENT,
      properties: {
        stream_name: streamName,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // stream deleted
  const trackStreamDeleted = ({ streamName }: StreamDeleted) => {

    const event = {
      event: TRACK_STREAM_DELETED_EVENT,
      properties: {
        stream_name: streamName,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // manage user access clicked
  const trackManageUserAccessClicked = ({ streamId }: ManageUserAccessClicked) => {

    const streamName = _.get(streams, `items[${streamId}].item.name`, '');

    const event = {
      event: TRACK_MANAGE_USER_ACCESS_CLICKED_EVENT,
      properties: {
        stream_name: streamName,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // user access updated
  const trackUserAccessUpdated = ({ }) => {

    const event = {
      event: TRACK_USER_ACCESS_UPDATED_EVENT,
      properties: {
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  // track stream created
  const trackStreamCreated = ({streamName, isCoverImageAdded, streamDescription}: StreamCreated) => {

    const event = {
      event: TRACK_CONTENT_HUB_STREAM_CREATED_EVENT,
      properties: {
        stream_name: streamName,
        isCoverImageAdded: isCoverImageAdded,
        stream_description: streamDescription
      }
    }

    dispatch(trackEventForAdoption(event));
  }



  return {
    trackStreamDetailViewed,
    trackStreamSelectionViewed,
    trackStreamEditViewed,
    trackStreamDeleteViewed,
    trackGroupDetailViewed,
    trackConnectedSourcesViewed,
    trackManageUserAccessViewed,
    trackStreamViewed,
    trackGroupViewed,
    trackManageSourceScreenView,
    trackStreamAdded,
    trackAddGroupClicked,
    trackAddGroupConfirmClicked,
    trackGroupAdded,
    trackAddAssetClicked,
    trackRenameClicked,
    trackRenameConfirmClicked,
    trackAssetRenamed,
    trackGroupRenamed,
    trackDeleteClicked,
    trackDeleteConfirmClicked,
    trackAssetDeleted,
    // trackGroupDeleted,
    trackCopyClicked,
    trackCopyConfirmClicked,
    trackCopyStreamSelected,
    trackAssetsCopied,
    trackGroupsCopied,
    trackMoveClicked,
    trackMoveConfirmClicked,
    trackMoveStreamSelected,
    trackAssetsMoved,
    trackGroupsMoved,
    trackManageSourceClicked,
    trackMapNewFolderClicked,
    trackConnectedSourceSelected,
    trackFolderSelected,
    trackSourceAdded,
    trackEditGroupClicked,
    trackGroupEdited,
    trackEditStreamClicked,
    trackEditStreamConfirmClicked,
    trackChangeBackgroundClicked,
    trackAddBannerClicked,
    trackBannerContentSelected,
    trackCropBannerClicked,
    trackBannerCropped,
    trackBannerAdded,
    trackBackgroundImageAdded,
    trackStreamEdited,
    trackDeleteStreamClicked,
    trackDeleteStreamConfirmClicked,
    trackStreamDeleted,
    trackManageUserAccessClicked,
    trackUserAccessUpdated,
    trackStreamCreated
  }
};